import React from "react";
import { useSelector } from "react-redux";
import Markdown from "react-markdown";

import { Loading, DrivingItem } from "../../../components";

import { Accordion, Container } from "react-bootstrap";

import Text from "../../../assets/json/strings.json";

import "./Driving.scss";

const Driving = () => {
  const { isLoading, data } = useSelector((state) => state.reportData);
  const { lang } = useSelector((state) => state.userData);

  return (
    <>
      {isLoading ? (
        <Loading />
      ) : (
        <>
          <h2>{Text[lang].pages.driving.title}</h2>
          <br />
          <p>{Text[lang].pages.driving.helpText}</p>

          <Container className="driving">
            <Accordion className="driving__accordion">
              {data.driving?.texts.map((item, index) => (
                <DrivingItem
                  title={Text[lang].pages.driving.cards[item.subarea]}
                  content={item.text}
                  hasImpact={item.impact}
                  eventKey={index}
                  key={index}
                  lang={lang}
                />
              ))}
            </Accordion>
          </Container>

          <hr style={{ margin: "2em 0" }} />

          <h5>{Text[lang].pages.driving.recommendations}</h5>
          {data.driving?.general_text.map((text, index) => (
            <Markdown key={index}>{text}</Markdown>
          ))}
        </>
      )}
    </>
  );
};

export default Driving;
